import {
  QUOTE_LINE_INFO_TABS,
  QUOTE_PRICE_FIELDS,
  QUOTE_PRICE_STRATEGY_BADGE_COLORS,
} from '../constants';
import { PriceStrategyUIConfigEntry } from '../types';

/**
 * Auto Configurator owns pricing for these lines. Gross margin, unit price and
 * lead time are overridden per quantity break there, and an edit here would be
 * discarded the next time the alpha quote is applied.
 */
export const alphaUIConfig: PriceStrategyUIConfigEntry = {
  badge: {
    color: QUOTE_PRICE_STRATEGY_BADGE_COLORS.USER,
    label: 'Auto Quote',
  },
  partDetailsExtraComponents: [],
  fields: [
    {
      field: QUOTE_PRICE_FIELDS.quantity,
      editable: false,
    },
    {
      field: QUOTE_PRICE_FIELDS.unitCost,
      editable: false,
    },
    {
      field: QUOTE_PRICE_FIELDS.unitPrice,
      editable: false,
    },
    {
      field: QUOTE_PRICE_FIELDS.grossMargin,
      editable: false,
    },
    {
      field: QUOTE_PRICE_FIELDS.contributionMargin,
      editable: false,
    },
    {
      field: QUOTE_PRICE_FIELDS.leadTimeWeeks,
      editable: false,
    },
  ],
  tabs: [QUOTE_LINE_INFO_TABS.COST_OVERVIEW, QUOTE_LINE_INFO_TABS.COST_BREAKS],
} as const;
